import Point from 'ol/geom/Point';
import { Feature } from 'ol';
import { TrackEntity } from '@/TrackEntity';
import { Styles } from './Styles';
import Ordered from './OrderHelper';
import PointFeature from './PointFeature';

export default class AnchorPointFeature extends PointFeature implements Ordered {
    isFirst = false
    isLast = false
    constructor(geometryOrProperties: Point|undefined, track: TrackEntity, order: number) {
        super(geometryOrProperties, track, order)
    }

    setFirst() {
        this.isFirst = true
        this.isLast = false
        this.setStyle(Styles.FirstAnchorDot)
    }

    setMid() {
        this.isFirst = false
        this.isLast = false
        this.setStyle(Styles.MidAnchorDot)
    }

    setLast() {
        this.isLast = true
        this.isFirst = false
        this.setStyle(Styles.LastAnchorDot)
    }

    getGeometry(): Point {
        return super.getGeometry()!
    }
}